<div class="card card-stats mb-4 mb-xl-0 h-100">
  <div class="card-body">
    <div class="row m-0">
      <div class="col py-0">
        <h5 class="card-title text-uppercase text-muted mb-2">{{ titulo }}</h5>
        @for (item of data; track $index) {
        <div style="font-size: 0.9rem">
          <span class="fw-bold me-2 text-muted">{{ item.label }}</span>
          <span class="fw-bold me-2">{{ item.valor | currency }}</span>
          @if (!isVacio(item.porcentaje)) {
          <small class="fw-normal">({{ item.porcentaje }}%)</small>
          }
        </div>
        }
      </div>
      <div class="col py-0">
        <div
          class="icon icon-shape text-white rounded-circle shadow {{
            iconContainerClass
          }}"
        >
          <i class="{{ iconClass }}"></i>
        </div>
      </div>
    </div>
  </div>
</div>
